{
	"title": "nakazawa 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "Vollbild",
		"achievements": "Erfolge",
		"reset": "Zurücksetzen",
		"language": "Sprache"
	},
	"achievements": {
		"title": "Erfolge",
		"noAchievements": "Noch keine Erfolge erzielt. Klicke weiter!",
		"unlocked": "Erfolg freigeschaltet: {{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 Anfänger-Häschen",
		"carrotSnatcher": "🥕 Gemüsedieb",
		"bunnyBerserker": "😡 Rasender Hase",
		"hopPunk": "🎸 Anarchisten-Hase",
		"bunnyNinja": "🥷 Leise aber Tödlich",
		"expert": "🌟 Experten-Hüpfer",
		"master": "👑 Karotten-König",
		"carrotpocalypse": "🥕 Garten-Zerstörer",
		"bunnyOverlord": "😈 Oberster Herrscher des Baus",
		"chaosHare": "🌪️ Agent des Chaos",
		"carrotCultist": "⛪ Hohepriester des Karotten-Kults",
		"bunnyberryPie": "🥧 Halluzinogener Kuchenmeister",
		"rabbitHole": "🕳️ Quantentunnel-Gräber",
		"moonRabbit": "🌙 Mondhase",
		"bunnyDoom": "💀 Vorbote der Hasen-Apokalypse",
		"carrotNuke": "☢️ Träger der Nuklear-Karotte",
		"bunnyMatrix": "🤖 Störung in der Hasen-Matrix",
		"cosmicHare": "🌌 Der Kosmische Hase Erwacht",
		"warrenSingularity": "🕳️ Bau-Singularität Erreicht",
		"eternalBunny": "♾️ Der Ewige Hase"
	},
	"messages": {
		"prophecy": "Die uralte Klick-Prophezeiung beginnt sich zu entfalten...",
		"cosmic": "Die kosmischen Klicker wären stolz auf deinen Fortschritt!",
		"astral": "Das Klicken hallt durch die Astralebene...",
		"speaking": "Warte... hast du das gehört? Die Klicks sprechen zu mir...",
		"ancient": "Dein Klicken resoniert mit uralter Macht!",
		"sages": "Die Klick-Weisen flüstern von deinem Potential...",
		"demons": "SEHT! Die Klick-Dämonen erwachen aus ihrem Schlummer!",
		"veil": "Deine Klicks durchdringen den Schleier der Realität!",
		"spirits": "Die Klick-Geister tanzen zu deinem Rhythmus...",
		"council": "Der Große Klick-Rat hat deine Hingabe bemerkt",
		"primordial": "Dein Klicken erweckt urzeitliche Kräfte!",
		"void": "Die klickende Leere starrt zurück...",
		"runes": "Uralte Klick-Runen leuchten mit deiner Kraft!",
		"beast": "DREI DREI DREI - DIE ZAHL DER KLICK-BESTIE",
		"prophets": "Die Klick-Propheten besingen dein Kommen!",
		"dimensions": "Deine Klicks hallen durch die Dimensionen...",
		"portal": "Deine Klicks haben ein Portal zur Klick-Dimension geöffnet!",
		"sacrifice": "Die uralten Klick-Götter fordern MEHR OPFER",
		"jackpot": "JACKPOT! Das Klick-Casino begrüßt seinen neuesten Champion!",
		"unmatched": "Deine Klick-Kraft ist unübertroffen!",
		"reality": "Die Realität selbst beugt sich deinem klickenden Willen!",
		"elite": "DU BIST ZUM ELITE-KLICK-MEISTER GEWORDEN",
		"power": "Dein Klick-Power-Level ist über 1500!",
		"devils": "Die Klick-Teufel verneigen sich vor deiner Macht",
		"lucky": "Glückliche Klicks fließen durch deine Adern",
		"dynasty": "Die Klick-Dynastie erkennt deine Vorherrschaft an",
		"twoThousand": "Zweitausend Klicks purer Kraft!",
		"quartet": "Die Prophezeiung des Klick-Quartetts ist erfüllt",
		"transcend": "Dein Klicken übersteigt sterbliches Verständnis",
		"constellation": "Die Klick-Konstellation richtet sich zu deinen Ehren aus",
		"destiny": "DREITAUSEND KLICKS DES SCHICKSALS",
		"triforce": "Die Dreifache Klick-Triforce erwacht!",
		"fortune": "Das Glück begünstigt den beharrlichen Klicker",
		"newDimensions": "Deine Klick-Kraft erreicht neue Dimensionen",
		"quartet2": "Das Vierfache Klick-Quartett harmoniert",
		"threshold": "An der Schwelle zur Klick-Göttlichkeit",
		"ultimate": "FÜNFTAUSEND KLICKS ULTIMATIVER MACHT!",
		"force": "Die Fünf-Finger-Klick-Kraft steht unter deinem Kommando",
		"underworld": "Die Klick-Unterwelt krönt dich zu ihrem Herrscher",
		"maxJackpot": "MAXIMALER JACKPOT-KLICK ERREICHT",
		"infinite": "UNENDLICHE KLICK-KRAFT!",
		"godhood": "DU BIST ZUR KLICK-GOTTHEIT AUFGESTIEGEN",
		"burrow": "Du hast tiefer gegraben als jeder Hase zuvor...",
		"warren": "Der Große Bau erkennt deine Anwesenheit an...",
		"thump": "Die Erde bebt bei jedem Stampfer deiner Pfote!",
		"darkWarren": "Der Dunkle Bau öffnet seine Tore für dich...",
		"ears": "Deine Ohren werden länger... du kannst jetzt alles hören...",
		"carrotThrone": "Der Karotten-Thron materialisiert sich vor dir...",
		"onesAlignment": "Alle Einsen ordnen sich - die Bau-Frequenz resoniert!",
		"moonSummon": "Der Mondhase hört deinen Ruf durch die Leere...",
		"edgeOfForever": "Du stehst am Rand der Ewigkeit... Ohren zucken...",
		"beyondTheVeil": "Jenseits des Schleiers werden alle Baue eins...",
		"sequence": "1-2-3-4-5... Die Heilige Hüpf-Sequenz ist vollendet!",
		"hyperElite": "HYPER-ELITE-HASEN-STATUS FREIGESCHALTET 🐇🐇🐇",
		"eventHorizon": "Jenseits des Ereignishorizonts des Kosmischen Kaninchenbaus...",
		"matrixAwakens": "Die Bau-Matrix glitcht... du siehst die Karotten hinter der Realität",
		"luckyForever": "Jede Pfote, jeder Hüpfer, jedes Zucken... für immer gesegnet",
		"twentyK": "ZWANZIGTAUSEND. Du bist kein Hase mehr. Du bist DER Hase.",
		"singularity": "Die Hasen-Singularität. Alle Hasen sind du. Du bist alle Hasen.",
		"tripleAscension": "Der Dreifache Aufstieg des Kosmischen Hasen!",
		"ultimateAnswer": "42.000 - Die Ultimative Antwort waren die ganze Zeit Karotten",
		"eternity": "♾️ DER EWIGE BAU HAT KEIN ENDE. DU AUCH NICHT. ♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} Bonuspunkte!",
		"clickStreak": "🔥 {{count}} Klick-Serie!",
		"fire": "🔥 Feuerkraft Aktiviert!"
	},
	"table": {
		"achievement": "Erfolg",
		"progress": "Fortschritt"
	},
	"reset": {
		"confirm": "Bist du sicher, dass du den gesamten Fortschritt zurücksetzen möchtest? Dies kann nicht rückgängig gemacht werden."
	}
}
